import styled from 'styled-components'
import { colors } from '../../../styles/theme'
import FormControl from './form-control'

const MultiCheck = styled.fieldset`
  p {
    color: ${props => props.theme.colors.typography.dark.text};
  }

  label {
    color: ${colors.neutral600};
  }

  ${FormControl} {
    margin-bottom: ${props => props.theme.spacing.base200};
  }

  &:not(:last-child) ${FormControl}:last-of-type {
    margin-bottom: ${props => props.theme.spacing.base600};
  }
`

export default MultiCheck
